// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"TN-z","carouselContainer":"UN-z"};